import React from 'react';
import { useTranslation } from 'react-i18next';
import { LANGUAGES, setLanguage } from '../i18n';
import './styles/languageSwitcher.css';

// compact — маленькая строка для страниц входа/регистрации; иначе — карточка в «Аккаунте»
export default function LanguageSwitcher({ compact = false }) {
  const { t, i18n } = useTranslation();
  const current = (i18n.language || 'ru').slice(0, 2);
  const buttons = (
    <div className="lang-options" role="radiogroup" aria-label={t('account.language')}>
      {LANGUAGES.map(l => (
        <button
          key={l.code}
          type="button"
          role="radio"
          aria-checked={current === l.code}
          className={`lang-btn ${current === l.code ? 'active' : ''}`}
          onClick={() => setLanguage(l.code)}
        >{l.label}</button>
      ))}
    </div>
  );
  if (compact) return <div className="lang-switcher lang-compact">{buttons}</div>;
  return (
    <div className="account-card lang-switcher">
      <div className="account-label"><span>🌐 {t('account.language')}</span></div>
      {buttons}
    </div>
  );
}
